// Client admin du journal des échecs de génération IA (lot P2). Lecture seule.
import { toast } from "sonner";

const ADMIN_API_BASE = `${import.meta.env.VITE_API_BASE_URL}/api/admin`;

export interface AdminAiFailure {
  id: string;
  userId: string | null;
  userEmail: string | null;
  prompt: string;
  subtype: string;
  costUsd: number;
  numTurns: number;
  sessionId: string | null;
  periodMonth: string | null;
  createdAt: string;
}

export interface ListFailuresParams {
  subtype?: string;
  search?: string;
  limit?: number;
  offset?: number;
}

async function adminFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const response = await fetch(url, {
    credentials: "include",
    ...options,
    headers: { "Content-Type": "application/json", ...options.headers },
  });
  if (response.status === 401) {
    toast.error("Session administrateur expirée. Redirection en cours...");
    setTimeout(() => {
      window.location.href = "/admin";
    }, 1000);
    throw new Error("Session expirée");
  }
  return response;
}

export const aiFailuresAdminService = {
  list: async (
    params: ListFailuresParams = {},
  ): Promise<{ items: AdminAiFailure[]; total: number }> => {
    const qs = new URLSearchParams();
    if (params.subtype) qs.set("subtype", params.subtype);
    if (params.search) qs.set("search", params.search);
    if (params.limit != null) qs.set("limit", String(params.limit));
    if (params.offset != null) qs.set("offset", String(params.offset));
    const res = await adminFetch(`${ADMIN_API_BASE}/ai-failures?${qs.toString()}`, {
      method: "GET",
    });
    if (!res.ok) throw new Error("Échec du chargement des échecs IA");
    const body = (await res.json()) as { data: AdminAiFailure[]; total: number };
    return { items: body.data, total: body.total };
  },
};
